import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const Text = styled.div`
    font-size: 16px;
    line-height: 1.2;
`;

const TextField = (props) => {
    const {
        label,
        translate,
        uppercase,
        value,
    } = props;

    if (utils.isEmpty(value)) {
        return null;
    }

    let formattedValue = value;

    if (uppercase) {
        if (typeof value === 'string') {
            formattedValue = value.toUpperCase();
        }
    }

    return (
        <TextFieldWrapper>
            { label &&
                <Label>{ translate(label) || '...' }</Label>
            }

            <Text>{ formattedValue }</Text>
        </TextFieldWrapper>
    );
};

TextField.defaultProps = {
    uppercase: false,
};

TextField.propTypes = {
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
    uppercase: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

export default translate(TextField);



// WEBPACK FOOTER //
// ./src/components/show/TextField.js